import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3yhucboxcl: FaireBrandEntity = {
  token: "b_3yhucboxcl",
  type: "brand",
  name: "LUCKY HONEY",
  avatarUrl:
    "https://cdn.faire.com/fastly/2f5d4030020a859259f0a0c93de0dce2ff0cf65089cb229004b521bf34ad2791.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a580fc0c73229df8505e330762b09f070fbbdbf8dc876cf27eb2cd6dcdb99425.png",
  logoUrl:
    "https://cdn.faire.com/fastly/2f5d4030020a859259f0a0c93de0dce2ff0cf65089cb229004b521bf34ad2791.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a580fc0c73229df8505e330762b09f070fbbdbf8dc876cf27eb2cd6dcdb99425.png",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 80,
  rating: 4.9,
  reviewCount: 188,
  isTopShop: true,
  isInsider: true,
  description:
    "Our story began with a simple beginning: As a Pilates instructor and fit model in NYC Jennifer saw the need for a more stylish and functional grippy sock. Combining her passion of Pilates and vast knowledge of how to produce a garment through her production fit modeling career, she came up with the Honey Sock. She launched in December of 2016 and the demand for socks came quickly! At this point, she partnered with her brother, a master engineer by trade but craving the start-up world. He moved to New York City and their adventure together continues today. Our socks are made to inspire performance, confidence, style, and grace and that is what our mission is every day.",
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:28:13.035Z",
    importedBy: "entity-db-cli",
  },
};
